import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TopnavbarComponent } from './topnavbar.component';
import { OpenedTasksModule2 } from '../../../tasks/openedTasks/openedTasks2.module';

// internacionalization
import {
  TranslateModule,
  MissingTranslationHandler
} from '@ngx-translate/core';
import { MyMissingTranslationHandler } from '../../missingtemplate.component';
import { HelpIndexComponent } from '../help/helpIndex.component';
import { HelpModule } from '../help/help.module';
import { ButtonModule } from 'primeng-lts/button';
@NgModule({
  declarations: [TopnavbarComponent],
  imports: [
    TranslateModule,
    CommonModule,
    ButtonModule,
    OpenedTasksModule2,
    HelpModule
  ],
  exports: [TopnavbarComponent],
  providers: [
    {
      provide: MissingTranslationHandler,
      useClass: MyMissingTranslationHandler
    }
  ]
})
export class TopnavbarModule { }
